import { render, staticRenderFns } from "./sidebar.vue?vue&type=template&id=2a585000&scoped=true&"
import script from "./sidebar.vue?vue&type=script&lang=ts&"
export * from "./sidebar.vue?vue&type=script&lang=ts&"
import style0 from "./sidebar.vue?vue&type=style&index=0&id=2a585000&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a585000",
  null
  
)

export default component.exports